import MyBillings from "./MyBillings";

export default MyBillings;
